
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 23.5C5.65926 23.5 0.5 18.3407 0.5 12C0.5 5.65926 5.65926 0.5 12 0.5C18.3407 0.5 23.5 5.65926 23.5 12C23.5 18.3407 18.3407 23.5 12 23.5ZM12 1.21423C6.05235 1.21423 1.21423 6.05235 1.21423 12C1.21423 17.9477 6.05235 22.7858 12 22.7858C17.9477 22.7858 22.7858 17.9477 22.7858 12C22.7858 6.05235 17.9477 1.21423 12 1.21423Z","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M17.8096 7.19943C17.5558 6.93352 17.1443 6.93352 16.8904 7.19943L9.10298 15.3564L6.10963 12.2211C5.8558 11.9552 5.44427 11.9552 5.19039 12.2211C4.93654 12.4869 4.93654 12.918 5.19039 13.1839L8.64336 16.8007C8.89711 17.0665 9.30895 17.0664 9.5626 16.8007L17.8096 8.16229C18.0635 7.89641 18.0634 7.46533 17.8096 7.19943Z","stroke":"currentColor"}})])
          )
        }
      }
    